// For a guide how to use feature flag please refer to https://confluence.strabag.io/display/4D/Gitlab+feature+flags
export enum IrisFeatureFlags {
  // Whether form block is hidden in the configuration of any template IRIS-34542
  FORMS_FULL_CONFIGURATION = 'forms_full_configuration',

  // Translating documents in the Forms module in a list view of documents or within the document itself IRIS-38882
  TRANSLATE_FORMS_DOCUMENT = 'translate_forms_document',

  // Whether during creation of new project manually the Organizationa Unit fields (UB, BE, DI and GR) have to be mandatory, IRIS-35119
  ORG_UNIT_MANDATORY = 'org_unit_mandatory',

  // Whether central project data page should be accessible
  CENTRAL_PROJECT_DATA = 'central_project_data',

  // Whether some thumbnails shouldn't be displayed according to file extension/size
  SMART_HIDE_THUMBNAILS = 'smart_hide_thumbnails',

  // Whether to show the trade field when editing or creating a project, as well as the description field should be required or not
  TRADE_AND_DESCRIPTION_MANDATORY = 'trade_and_description_mandatory',

  // Whether to enable project language translation instead of user language translation for PDF generation in projects
  PROJECT_LANG_PDF_GENERATION = 'project_lang_pdf_generation',

  // Whether impersonating users is allowed or not
  IMPERSONATE_USER = 'impersonate_user',

  // Whether template import functionality is allowed or not
  HIDE_NEW_TEMPLATE_IMPORT = 'hide_new_template_import',

  // Whether to use new marketplace binding for template import functionality
  MARKETPLACE_NEW_BINDING = 'marketplace_new_binding',

  // Indicates the message source used for static frontend translations
  STATIC_TRANSLATIONS_MESSAGE_SOURCE = 'static_translations_message_source',

  // Whether exporting documents for projects is enabled
  EXPORT_PROJECT_DOCUMENTS = 'export_project_documents',
}
